import { Icon } from '@mediahuis/chameleon-react';
import { Checkmark, Close } from '@mediahuis/chameleon-theme-wl/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeaturesList = _ref => {
  let {
    availableOnly = false,
    className,
    gap = '0.25rem',
    hideUnavailable = false,
    lineThroughUnavailable = false,
    iconSize = 'medium',
    items
  } = _ref;
  const sortedItems = [...items].sort((a, b) => Number(b.isAvailable) - Number(a.isAvailable));
  return /*#__PURE__*/_jsx("ul", {
    className: className,
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap
    },
    children: (hideUnavailable ? sortedItems : items).map(item => {
      if (availableOnly && item.isAvailable || !availableOnly || hideUnavailable) {
        return /*#__PURE__*/_jsxs("li", {
          style: {
            color: item.isAvailable ? 'inherit' : 'var(--color-grey-40)',
            display: 'flex',
            gap: '0.25rem',
            visibility: hideUnavailable && !item.isAvailable ? 'hidden' : undefined,
            textDecoration: !item.isAvailable && lineThroughUnavailable ? 'line-through' : undefined
          },
          children: [/*#__PURE__*/_jsx(Icon, {
            as: item.isAvailable ? Checkmark : Close,
            color: item.isAvailable ? 'colorGreen50' : 'colorGrey40',
            size: iconSize
          }), item.children]
        }, item.key);
      }
      return null;
    })
  });
};
export default FeaturesList;